<template>
  <v-row align="center" class="mb-5">
    <v-col cols="12" sm="12" md="4" lg="4" xl="4">
      <v-img
        :src="image"
        min-height="185px"
      ></v-img>
    </v-col>
    
    <v-col cols="12" sm="12" md="8" lg="8" xl="8">
      <v-row>
        <v-col cols="12">
          <h3 class="primary--text mb-2">{{ title }}</h3>
          <span class="paragraph line-clamp-5">
            {{ content }}
          </span>
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12">
          <span class="clickable primary--text">
            Read More
          </span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'AnnouncementCard',

    props: {
      title: { type: String, default: '' },
      content: { type: String, default: '' },
      image: { type: String, default: '' }
    }
  }
</script>

<style lang="scss" scoped>
.paragraph {
  color: #666666;
  font-size: 15px;
}
</style>